import React from 'react';

const ArrowIcon = () => (
  <svg width='24px' height='24px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M15 7L10 12L15 17' stroke='#000000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
  </svg>
);

export default ArrowIcon;
